import request from '../untils/request';

export const supplierListApi = params => {
  return request({
    url: '/goods/supplier/supplier-list',
    params,
  });
};
export const classListApi = params => {
  return request({
    url: '/goods/goods-class/get-class-with-children',
    authCode: 'GOODS-CLASS_GET-CLASS-WITH-CHILDREN',
    params,
  });
};
export const goodsListApi = params => {
  return request({
    url: '/goods/goods-basic/index',
    authCode: 'GOODS-BASIC_INDEX',
    params,
  });
};
export const categoryListApi = params => {
  return request({
    url: '/goods/goods-class/index',
    authCode: 'GOODS-CLASS_INDEX',
    params,
  });
};
export const goodsTypesApi = params => {
  return request({
    url: '/goods/type/index',
    authCode: 'TYPE_INDEX',
    params,
  });
};
export const specListApi = params => {
  return request({
    url: '/goods/type/spec-list',
    params,
  });
};
export const goodsTypeUpdate = params => {
  return request({
    url: '/goods/type/update',
    authCode: 'TYPE_INDEX',
    params,
  });
};
export const goodsTypeCreate = params => {
  return request({
    url: '/goods/type/create',
    authCode: 'TYPE_INDEX',
    params,
  });
};

export const goodsServiceApi = params => {
  return request({
    url: '/goods/goods-service/index',
    authCode: 'GOODS-SERVICE_INDEX',
    params,
  });
};

export const goodsServiceUpdate = params => {
  return request({
    url: '/goods/goods-service/update',
    authCode: 'GOODS-BASIC_INDEX',
    params,
  });
};

export const goodsServiceCreate = params => {
  return request({
    url: '/goods/goods-service/create',
    authCode: 'GOODS-BASIC_INDEX',
    params,
  });
};

export const goodsClassApi = params => {
  return request({
    url: '/goods/goods-class/index',
    authCode: 'GOODS-CLASS_INDEX',
    params,
  });
};

export const goodsSortApi = params => {
  return request({
    url: '/goods/goods-basic/sort-form',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsActivityApi = params => {
  return request({
    url: '/goods/goods-activity/index',
    authCode: 'GOODS-ACTIVITY_INDEX',
    params,
  });
};

export const shelfStatusApi = params => {
  return request({
    url: '/goods/goods-basic/shelf-status',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsDeleteApi = params => {
  return request({
    url: '/goods/goods-basic/delete',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsChildrenListApi = params => {
  return request({
    url: '/goods/goods/goods-list',
    authCode: 'GOODS-BASIC_INDEX',
    params,
  });
};

export const goodsServiceListApi = params => {
  return request({
    url: '/goods/goods-service/service-list',
    params,
  });
};

export const createGoodsBasicApi = params => {
  return request({
    url: '/goods/goods-basic/create-save-basic',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsTagListApi = params => {
  return request({
    url: '/goods/goods-tag/tag-list',
    params,
  });
};

export const goodsBasicDetailApi = params => {
  return request({
    url: '/goods/goods-basic/detail',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const specValueCreate = params => {
  return request({
    url: '/goods/spec-value/create',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsBasicCreate = params => {
  return request({
    url: '/goods/goods-basic/create-goods',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsBasicEdit = params => {
  return request({
    url: '/goods/goods-basic/edit-save-basic',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsImageDatail = params => {
  return request({
    url: '/goods/goods-basic/get-goods-image',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsImageDeit = params => {
  return request({
    url: '/goods/goods-basic/save-goods-basic-image',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsSpecDeit = params => {
  return request({
    url: '/goods/goods-basic/edit-goods-basic-spec',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsSpecSoldOutDeit = params => {
  return request({
    url: '/goods/goods-basic/goods-del',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};

export const goodsActivityDeleteApi = params => {
  return request({
    url: '/goods/goods-activity/delete',
    authCode: 'GOODS-ACTIVITY_DELETE',
    params,
  });
};

export const goodsActivitySortApi = params => {
  return request({
    url: '/goods/goods-activity/sort',
    authCode: 'GOODS-ACTIVITY_SORT',
    params,
  });
};

export const goodsdActivityApi = params => {
  return request({
    url: '/goods/goods-activity/index',
    authCode: 'GOODS-ACTIVITY_INDEX',
    params,
  });
};

export const goodsMaterialApi = params => {
  return request({
    url: '/goods/material/index',
    authCode: 'MATERIAL_INDEX',
    params,
  });
};

export const goodsMaterialViewApi = params => {
  return request({
    url: '/goods/material/view',
    authCode: 'MATERIAL_INDEX',
    params,
  });
};

export const goodsClassLevelOneListApi = params => {
  return request({
    url: '/goods/goods-class/level-one-list',
    params,
  });
};

export const goodsClassStatusApi = params => {
  return request({
    url: '/goods/goods-class/status',
    params,
  });
};

export const goodsClassUpdateApi = params => {
  return request({
    url: '/goods/goods-class/update',
    authCode: 'GOODS-CLASS_INDEX',
    params,
  });
};
export const goodsClassCreateApi = params => {
  return request({
    url: '/goods/goods-class/create',
    authCode: 'GOODS-CLASS_INDEX',
    params,
  });
};
export const goodsUnMaterialApi = params => {
  return request({
    url: '/goods/material/un-audited-list',
    authCode: 'GOODS-CLASS_INDEX',
    params,
  });
};
export const goodsServiceStatusApi = params => {
  return request({
    url: '/goods/goods-service/status',
    params,
  });
};
export const goodsTypeStatusApi = params => {
  return request({
    url: '/goods/type/status',
    params,
  });
};
export const goodsSpecListApi = params => {
  return request({
    url: '/goods/spec/index',
    authCode: 'SPEC_INDEX',
    params,
  });
};
export const goodsSpecUpdate = params => {
  return request({
    url: '/goods/spec/update',
    authCode: 'SPEC_INDEX',
    params,
  });
};
export const goodsSpecCreate = params => {
  return request({
    url: '/goods/spec/create',
    authCode: 'SPEC_INDEX',
    params,
  });
};
export const goodsSpecStatusApi = params => {
  return request({
    url: '/goods/spec/status',
    params,
  });
};
export const goodsMaterialVerifyApi = params => {
  return request({
    url: '/goods/material/verify',
    authCode: 'MATERIAL-EDIT',
    params,
  });
};
export const goodsMaterialDelApi = params => {
  return request({
    url: '/goods/material/delete',
    authCode: 'MATERIAL-EDIT',
    params,
  });
};
export const logoutApi = params => {
  return request({
    url: '/system/user/logout',
    params,
  });
};
export const goodsTagApi = params => {
  return request({
    url: '/goods/goods-tag/index',
    authCode: 'GOODS-TAG_INDEX',
    params,
  });
};
export const goodsTagIsShowSelectApi = params => {
  return request({
    url: '/goods/goods-tag/list',
    params,
  });
};
export const goodsTagDeleteApi = params => {
  return request({
    url: '/goods/goods-tag/delete',
    authCode: 'GOODS-TAG_DELETE',
    params,
  });
};
export const goodsTagUpdateApi = params => {
  return request({
    url: '/goods/goods-tag/update',
    authCode: 'GOODS-TAG_INDEX',
    params,
  });
};
export const goodsTagCreateApi = params => {
  return request({
    url: '/goods/goods-tag/create',
    authCode: 'GOODS-TAG_INDEX',
    params,
  });
};
export const goodsTagGoodsApi = params => {
  return request({
    url: '/goods/goods-tag/tag-goods',
    authCode: 'GOODS-TAG_INDEX',
    params,
  });
};
export const goodsTagGoodsDelApi = params => {
  return request({
    url: '/goods/goods-tag/del-tag-goods',
    authCode: 'GOODS-TAG_DEL-TAG-GOODS',
    params,
  });
};
export const goodsTagGoodsSortApi = params => {
  return request({
    url: '/goods/goods-tag/sort',
    authCode: 'GOODS-TAG_SORT',
    params,
  });
};
export const goodsTagGoodsChoseApi = params => {
  return request({
    url: '/goods/goods-tag/goods-select',
    authCode: 'GOODS-TAG_GOODS-SELECT',
    params,
  });
};
export const goodsTagGoodsBindApi = params => {
  return request({
    url: '/goods/goods-tag/add-tag-goods',
    authCode: 'GOODS-TAG_ADD-TAG-GOODS',
    params,
  });
};
export const goodsDetailsApi = params => {
  return request({
    url: '/goods/goods-basic/detail',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsDetailImgApi = params => {
  return request({
    url: '/goods/goods-basic/get-goods-image',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsVerifyApi = params => {
  return request({
    url: '/goods/goods-basic/goods-verify',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsOnlineSkuApi = params => {
  return request({
    url: '/goods/goods-basic/putaway-list',
    params,
  });
};
export const goodsOfflineSkuApi = params => {
  return request({
    url: '/goods/goods-basic/goods-del',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsSkuDelGoodsApi = params => {
  return request({
    url: '/goods/goods-basic/sku-del-goods',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsEditGoodsStockApi = params => {
  return request({
    url: '/goods/goods-basic/edit-goods-stock-spec',
    authCode: 'GOODS-BASIC_EDIT',
    params,
  });
};
export const goodsResetGoodsIdApi = params => {
  return request({
    url: '/goods/goods-basic/reset-id',
    authCode: 'GOODS-BASIC_RESET-ID',
    params,
  });
};
export const goodsMaterialCreateApi = params => {
  return request({
    url: '/goods/material/create',
    authCode: 'MATERIAL-EDIT',
    params,
  });
};
export const goodsMaterialUpdateApi = params => {
  return request({
    url: '/goods/material/update',
    authCode: 'MATERIAL-EDIT',
    params,
  });
};
export const storageLogApi = params => {
  return request({
    url: '/goods/goods-basic/storage-log',
    authCode: 'GOODS-BASIC_INDEX',
    params,
  });
};